<script lang="ts">
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import type {ExternalLoanLoanability} from 'typings/portaro.be.types';

    export let capability: ExternalLoanLoanability;
</script>

<a href="{capability.url}" target="_blank">
    <IconedContent trailingIcon="link" justify="start">
        <slot/>
    </IconedContent>
</a>